import React from 'react';

const GallerySection = () => {
  const galleryImages = [
    {
      url: 'https://customer-assets.emergentagent.com/job_o2-nails-hyderabad/artifacts/eutr5k53_10bbfade-b8e2-46de-906e-c25e93f7ac70.JPG',
      alt: 'Custom gel nail extensions with intricate brown and nude nail art at O2 Nails Hyd Kondapur',
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_o2-nails-hyderabad/artifacts/lg6loeon_496ce527-9189-487d-8a15-eacfa3dcaec7.JPG',
      alt: 'Festive red gel polish and custom nail art design at Sarath City Capital Mall nail salon',
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_o2-nails-hyderabad/artifacts/dygum5wl_764cabcf-8e2b-4bd4-9525-d6cac77e2365.JPG',
      alt: 'Black and pink acrylic nail extensions with professional custom nail art in Hyderabad',
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_o2-nails-hyderabad/artifacts/9xggc953_1551dd33-7d2d-43c6-90ab-ab4f868a172b.JPG',
      alt: 'Elegant navy blue French tip nails with custom floral design at O2 Nails Hyd premium studio',
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_o2-nails-hyderabad/artifacts/vfqebwal_9034b436-7f8f-4ab0-9b54-e8494e6c0a6b.JPG',
      alt: 'Pink gel polish with bespoke 3D bow and heart nail art by expert technicians near Hitech City',
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_o2-nails-hyderabad/artifacts/8008smb4_c902773f-8d3d-45d0-928c-bb08d3789f09.JPG',
      alt: 'Green and gold glitter ombre nail extensions done at the best nail salon in Kondapur',
    },
  ];

  return (
    <section className="gallery-section">
      <div className="gallery-container">
        <h2 className="gallery-title">Our Artistry</h2>
        <p className="gallery-subtitle">Experience the perfection of our expert nail artists</p>
        
        <div className="gallery-grid">
          {galleryImages.map((image, index) => (
            <div key={index} className="gallery-item">
              <div className="gallery-image-wrapper">
                <img 
                  src={image.url} 
                  alt={image.alt}
                  className="gallery-image"
                  loading="lazy"
                />
                <div className="gallery-overlay"></div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default GallerySection;
